import React from 'react'
import ReactDOM from 'react-dom/client'
import LModal from "./LModal"


/**
 *  Автоматически создаваемое модальное окно
 */
export default class LModalOpener {

    static #count = 0

    #root
    #element

    #content = null
    #onClose = null
    #isOpen = false


    /**
     * @param {function()} onClose
     */
    constructor({ onClose }) {
        LModalOpener.#count++
        this.#onClose = onClose
    }


    open() {
        this.#isOpen = true
        this.#render()
    }


    close( notify = true ) {
        this.#isOpen = false
        if(notify) this.#onClose?.()
        this.#dispose()
    }


    #dispose(){
        this.#root.unmount()
        this.#root = undefined
        this.#element.remove()
    }


    setContent(content) {
        this.#content = content
        this.#render()
    }


    #render() {
        if(this.#element==null){
            this.#element = document.createElement('div')
            this.#element.id = `LModalRoot_${LModalOpener.#count}`
            document.body.append(this.#element)
            this.#root = ReactDOM.createRoot(this.#element)
        }
        // Скрыто
        if(!this.#isOpen){
            this.#root.render(null)
            return
        }
        this.#root.render(
            <LModal onClosePressed={ ()=>this.close() }>
                {this.#content}
            </LModal>
        )
    }

}